import axiosPrivate from "./axiosPrivate";

const getPagosPlanilla = (mes, area = '', estado = '1') => {
    return axiosPrivate.get(`pagos-planilla?mes=${mes}&area=${area}&estado=${estado}`);
};

const getColaboradoresConfig = (area = '', perfil = '') => {
    return axiosPrivate.get(`pagos-planilla/config?area=${area}&perfil=${perfil}`);
};

const updateColaboradorConfig = (data) => {
    return axiosPrivate.post(`pagos-planilla/config`, data);
};

const getBonosConfig = (area = '', perfil = '', tipoBono = 1) => {
    return axiosPrivate.get(`pagos-planilla/bonos-config?area=${area}&perfil=${perfil}&tipo_bono=${tipoBono}`);
};

const updateBono = (data) => {
    return axiosPrivate.post(`pagos-planilla/bonos-config`, data);
};

const getAportacionesConfig = (area = '', perfil = '') => {
    return axiosPrivate.get(`pagos-planilla/aportaciones-config?area=${area}&perfil=${perfil}`);
};

const updateAportacion = (data) => {
    return axiosPrivate.post(`pagos-planilla/aportaciones-config`, data);
};

const getRetencion5taConfig = (area = '', perfil = '') => {
    return axiosPrivate.get(`pagos-planilla/retencion5ta-config?area=${area}&perfil=${perfil}`);
};

const updateRetencion5ta = (data) => {
    return axiosPrivate.post(`pagos-planilla/retencion5ta-config`, data);
};

const registrarPago = (data) => {
    return axiosPrivate.post(`pagos-planilla/registrar`, data);
};

const validarPlanilla = (data) => {
    return axiosPrivate.post(`pagos-planilla/validar`, data);
};

const actualizarPago = (data) => {
    return axiosPrivate.post(`pagos-planilla/actualizar-pago`, data);
};

const PagosPlanillaService = {
    getPagosPlanilla,
    getColaboradoresConfig,
    updateColaboradorConfig,
    getBonosConfig,
    updateBono,
    getAportacionesConfig,
    updateAportacion,
    getRetencion5taConfig,
    updateRetencion5ta,
    registrarPago,
    validarPlanilla,
    actualizarPago,
};

export default PagosPlanillaService;
